import React from 'react';
import { PropTypes } from 'prop-types';

import { Field } from '@ontruck/orc';

const BillingInfoForm = ({
  className,
  t,
  handleChangeFiscalInfo,
  handleChangeBillingContact,
  errors,
  country,
}) => (
  <div className={className}>
    <h1>{t('BillingInfoForm.title')}</h1>
    {errors &&
      Object.keys(errors).some(
        (errorKey) =>
          ['tax_number', 'name', 'last_name', 'phone', 'email'].indexOf(
            errorKey
          ) >= 0
      ) && <p className="error">{t('BillingInfoForm.error')}</p>}
    <div className="field-row">
      <div className="half">
        <Field
          id="tax_number"
          type="text"
          name="tax_number"
          onChange={handleChangeFiscalInfo}
          label={t('BillingInfoForm.tax_number')}
          error={!!errors && !!errors.tax_number}
          fullWidth
        />
      </div>
    </div>

    {country && country.country === 'UK' && (
      <div className="field-row">
        <div className="half">
          <Field
            id="vat"
            type="text"
            name="vat"
            onChange={handleChangeFiscalInfo}
            label={t('BillingInfoForm.vat')}
            error={!!errors && !!errors.vat}
            fullWidth
          />
        </div>
      </div>
    )}

    <div className="billing-person">
      <h2>{t('BillingInfoForm.billing_person.title')}</h2>
      <p>{t('BillingInfoForm.billing_person.info')}</p>

      <div className="field-row">
        <div className="flex-2">
          <Field
            id="name"
            type="text"
            name="name"
            onChange={handleChangeBillingContact}
            label={t('BillingInfoForm.billing_person.name')}
            error={!!errors && !!errors.name}
            fullWidth
          />
        </div>
        <div className="flex-3">
          <Field
            id="last_name"
            type="text"
            name="last_name"
            onChange={handleChangeBillingContact}
            label={t('BillingInfoForm.billing_person.last_name')}
            error={!!errors && !!errors.last_name}
            fullWidth
          />
        </div>
      </div>

      <div className="field-row">
        <div className="flex-2">
          <Field
            id="phone"
            type="text"
            name="phone"
            onChange={handleChangeBillingContact}
            label={t('BillingInfoForm.billing_person.phone')}
            error={!!errors && !!errors.phone}
            fullWidth
          />
        </div>
        <div className="flex-3">
          <Field
            id="email"
            type="text"
            name="email"
            onChange={handleChangeBillingContact}
            label={t('BillingInfoForm.billing_person.email')}
            error={!!errors && !!errors.email}
            fullWidth
          />
        </div>
      </div>
    </div>
  </div>
);

BillingInfoForm.propTypes = {
  t: PropTypes.func,
  className: PropTypes.string,
  handleChangeFiscalInfo: PropTypes.func,
  handleChangeBillingContact: PropTypes.func,
  errors: PropTypes.string.isRequired,
  country: PropTypes.string,
};

BillingInfoForm.defaultProps = {
  t: (t) => t,
  className: '',
  handleChangeFiscalInfo: () => ({}),
  handleChangeBillingContact: () => ({}),
  country: '',
};

export default BillingInfoForm;
